<template>
	<div class="container">
		<img class="back_ground_img" src="@/assets/background.png"/>
		<img class="logo" src="@/assets/galaku_logo.png"/>
		<div class="title title1">GALAKU</div>
		<div class="title title2">APP</div>
		<div class="title_small">iOS/Android Download</div>
		<div class="menu-container">
			<div class="menu-btn" @click="iosClick">
				<img class="btn_ground_img" src="@/assets/ios_icon.png"/>
				<div class="text-btn">
					<div class="text-item">Download</div>
				</div>
			</div>
			
			<div class="menu-btn menu-btn2"  @click="androidClick">
				<img class="btn_ground_img" src="@/assets/android_icon.png"/>
				<div class="text-btn">
					<div class="text-item">Download</div>
				</div>
			</div>
			
		</div>
	</div>
</template>


<script>
	
import Vue from 'vue'
import axios from 'axios'

export default {
  name: 'app',
  components: {
  },
  
  data(){
	  return{
		  barWidth:0,
		  progressWidth:0,
		  isApkDownloaded:false,
		  filePath:""
	  }
  },
  
  computed:{
  },
  
 
  mounted() {
	  // const width = this.$refs.barRef.offsetWidth;
	  // const height = this.$refs.barRef.offsetHeight;
	  
	  // let windowWidth = window.innerHeight;
	  // let windowHeight = window.innerHeight;
	  // console.log("width:"+width);
	  // console.log("height:"+height);
	  
	  // this.$data.barWidth = width;
  },
  
  
  beforeDestroy() {
  },
  
  created() {
		// window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
	// 扩展API是否准备好，如果没有则监听“plusready"事件
  },
  
  destroyed() {
		window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
  
 
  methods:{
		beforeunloadFn(e) {
			console.log('刷新或关闭')
		}, 

		iosClick() {
		   location.href="https://itunes.apple.com/app/id1576326289"
		},
		
		
		
		androidClick() {
		   location.href="http://app.hudouchat.com/gal"
		   // location.href="http://a.app.qq.com/o/simple.jsp?pkgname=com.wensheng.rejoapplication";
		}
	}

}
</script>

<style>
	#app {
	/*  font-family: 'Avenir', Helvetica, Arial, sans-serif;
	  -webkit-font-smoothing: antialiased;
	  -moz-osx-font-smoothing: grayscale;
	  text-align: center;
	  color: #2c3e50;
	  margin-top: 60px; */
	  padding: 0;
	  margin: 0;
	}

	.container{
		padding: 0;
		margin: 0;
		height: 100vh;
		width: 100vw;
		position: relative;
	}
	
	.back_ground_img{
		position: absolute;
		left: 0;
		top: 0;
		height: 100vh;
		width: 100vw;
		z-index: -100;
	}
	
	.logo{
		margin-left: 20px;
		margin-top: calc(100vh*0.15);
		width: 70px;
		height: 70px;
	}
	
	.title{
		margin-left: 20px;
		font-size: 70px;
		color: black;
		font-weight:bolder
	}
	
	.title1{
		margin-top: 20px;
	}
	
	.title2{
		margin-top: -15px;
	}
	
	.title_small{
		margin-left: 20px;
		font-size: 22px;
		color: #333333;
		margin-top: 10px;
	}
	
	.menu-container{
		width: 100vw;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-top: 40px;
	}
	
	
	.menu-btn{
		width: 254px;
		height: 54px;
		position: relative;
	}
	
	.btn_ground_img{
		left: 0;
		top: 0;
		width: 254px;
		height: 54px;
		position: absolute;
	}
	
	.text-btn{
		left: 50px;
		top: 0;
		right: 50px;
		bottom: 0;
		position: absolute;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	
	.text-item{
		color: white;
		font-size: 17px;
	}
	
	.menu-btn2{
		margin-top: 30px;
	}
	

</style>
